"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageH5 = void 0;
var shared_utils_1 = require("@uip-alpha/shared-utils");
var storageType;
(function (storageType) {
    storageType["local"] = "local";
    storageType["session"] = "session";
})(storageType || (storageType = {}));
var StorageH5 = /** @class */ (function () {
    function StorageH5(type) {
        this.storage = type === storageType.local ? window.localStorage : window.sessionStorage;
    }
    StorageH5.prototype.get = function (key) {
        return shared_utils_1.parse(this.storage.getItem(key));
    };
    StorageH5.prototype.set = function (key, val) {
        this.storage.setItem(key, shared_utils_1.stringify(val));
    };
    StorageH5.prototype.remove = function (key) {
        this.storage.removeItem(key);
    };
    return StorageH5;
}());
exports.StorageH5 = StorageH5;
var storageH5 = {
    name: 'storageH5',
    install: function (UIP) {
        /** 挂载localStorage和sessionStorage */
        UIP.storage = UIP.localStorage = new StorageH5('local');
        UIP.sessionStorage = new StorageH5('session');
    }
};
exports.default = storageH5;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/storage-h5/dist/index.js
// module id = MrBJ
// module chunks = 1